// Global
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { PlaceholderComponentProps } from '@sitecore-jss/sitecore-jss-react/types/components/Placeholder';
// Lib
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import { classnames } from 'tailwindcss-classnames';
import SvgIcon, { SvgIconOption } from '../SvgIcon/SvgIcon';

type PlaceholderMessageProps = {
  icon: SvgIconOption;
  message: string;
};

const PlaceholderMessage = ({ icon, message }: PlaceholderMessageProps): JSX.Element => {
  const placeholderWrapperClasses = classnames('text-xxs', 'text-center', 'p-1', 'font-bold');

  const placeholderNameClasses = classnames(
    'bg-theme-text',
    'text-theme-bg',
    'inline-block',
    'px-1.5',
    'py-0.5',
    'leading-1',
    'mx-2',
    'opacity-80'
  );

  return (
    <div className={placeholderWrapperClasses}>
      Placeholder:
      <span className={placeholderNameClasses}>{message}</span>
      <SvgIcon icon={icon as SvgIconOption} viewBoxSize="0 0 48 48" size="em" />
    </div>
  );
};

/**
 * Adds a visual area for authors to click when placeholder is empty
 * in Experience Editor
 */

const PlaceholderWrapper = ({ name, ...props }: PlaceholderComponentProps): JSX.Element => {
  const isEE = useExperienceEditor();

  if (isEE) {
    return (
      <div className={classnames('w-full')}>
        <PlaceholderMessage message={name} icon="arrow-down" />
        <Placeholder name={name} {...props} />
        <PlaceholderMessage message={name} icon="arrow-up" />
      </div>
    );
  }

  return <Placeholder name={name} {...props} />;
};

export default PlaceholderWrapper;
